export default __webpack_public_path__ + "static/media/icon_filter.c73bf324.svg";